import z from 'zod';

export const languageSchema = z.string().regex(/^[a-z]{2}-[A-Z]{2}$/);

z.globalRegistry.add(languageSchema, { id: 'language' });

export type LanguageSchema = z.infer<typeof languageSchema>;

export const languages = z.array(languageSchema);

z.globalRegistry.add(languages, { id: 'languages' });

export type LanguagesSchema = z.infer<typeof languages>;
